/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { financialsCoreMetricDtoSchema } from "./financialsCoreMetricDtoSchema.ts";
import { financialsKeyContractDtoSchema } from "./financialsKeyContractDtoSchema.ts";
import { financialsPipelineEntryDtoSchema } from "./financialsPipelineEntryDtoSchema.ts";
import { financialsRetentionMetricDtoSchema } from "./financialsRetentionMetricDtoSchema.ts";
import { financialsStatementsDtoSchema } from "./financialsStatementsDtoSchema.ts";
import { financialsTermsAnalysisDtoSchema } from "./financialsTermsAnalysisDtoSchema.ts";
import { z } from "zod/v4";

export const financialsSectionDtoSchema = z.object({
  get coreMetrics() {
    return z.array(financialsCoreMetricDtoSchema).optional();
  },
  get unitEconomics() {
    return z.array(financialsCoreMetricDtoSchema).optional();
  },
  get retention() {
    return financialsRetentionMetricDtoSchema.nullish();
  },
  get statements() {
    return financialsStatementsDtoSchema.optional();
  },
  get pipeline() {
    return z.array(financialsPipelineEntryDtoSchema).optional();
  },
  get keyContracts() {
    return z.array(financialsKeyContractDtoSchema).optional();
  },
  get termsAnalysis() {
    return financialsTermsAnalysisDtoSchema.nullish();
  },
});
